<template>
  <v-container fluid class="py-0 pl-4">
    <v-row>
      <v-col cols="12" sm="5">
        <v-select
          :value="filterParams.type"
          :items="types"
          :label="$t('type')"
          clearable
          @change="updateFilter('type', $event)"
          @click:clear="updateFilter('type', null)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ArticleFilter',

  props: {
    filterParams: {
      type: Object,
      required: true,
    },
  },

  computed: mapGetters('articles', ['types']),

  methods: {
    updateFilter(key, value) {
      const query = { ...this.filterParams };
      if (value) {
        query[key] = value;
      } else {
        delete query[key];
      }
      this.$emit('change', query);
    },
  },
};
</script>

<style scoped></style>
